import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "vp-web-app-uninvited",
  templateUrl: "./uninvited.component.html",
  styleUrls: ["./uninvited.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UninvitedComponent {}
